var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.526 5.74002L10.646 4.80004C10.386 4.67337 10.1394 4.33337 10.086 4.0467L9.80602 2.34669C9.62602 1.26003 8.83935 1.00669 8.05269 1.78669L6.72602 3.11338C6.50602 3.33338 6.07269 3.46002 5.75935 3.38669L4.11935 3.00671C2.82601 2.70671 2.31935 3.40003 2.99935 4.54003L3.94602 6.13337C4.11935 6.42004 4.11935 6.90003 3.94602 7.1867L2.99935 8.78004C2.32602 9.92004 2.82601 10.6134 4.11935 10.3134L5.75935 9.93336C6.06602 9.86003 6.49935 9.9867 6.72602 10.2067L8.05269 11.5334C8.83269 12.3134 9.61936 12.06 9.80602 10.9734L10.086 9.27337C10.1327 8.9867 10.386 8.6467 10.646 8.52003L12.526 7.58003C13.546 7.08003 13.546 6.25336 12.526 5.74002Z",
    stroke: "#0C80F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 10.667V14.667",
    stroke: "#0C80F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 12.667L3.33398 14.667",
    stroke: "#0C80F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0003V14.667",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.064981fd005b7377f475177f5143949d.svg";
export { ForwardRef as ReactComponent };